import React from 'react';

export const UnknownContent: React.FC = () => <React.Fragment>Template non trouvée</React.Fragment>;
